import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyBh7-DtNFbHixvGr3nAFUD-BHHt8X2hceA",
    authDomain: "okkong-f0744.firebaseapp.com",
    projectId: "okkong-f0744",
    storageBucket: "okkong-f0744.firebasestorage.app",
    messagingSenderId: "20358372085",
    appId: "1:20358372085:web:444496fa5441b1548403bc",
    measurementId: "G-W3889PW7QF"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Export auth and provider
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export { analytics };